import api from "./api";

// Creates a Stripe Checkout session on the backend and redirects the browser to it.
// Amounts are always resolved server-side; we only send references.
export async function startCheckout(payload) {
  const { data } = await api.post("/payments/checkout/session", {
    ...payload,
    origin_url: window.location.origin,
  });
  if (data?.url) {
    window.location.href = data.url;
    return true;
  }
  throw new Error("No checkout URL received");
}
